import { GET_Address_Details, GET_Credentials } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const Get_Credentials = createAsyncThunk(
  "Credentials/get",
  async (thunkAPI) => {
    try {
      const response = GET_Credentials();
      const data = await response;
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
